<app-view-item *ngIf="readonly" [text]="getLabel(selected)" [borderless]="borderless"></app-view-item>
<div class="stock-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)"
    (nzOpenChange)="onDropdownOpenChange($event)" (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)"
    (click)="handleClick($event)" [nzCustomTemplate]="displayTpl" [(ngModel)]="value"
    (ngModelChange)="valueChanged($event)" [nzAllowClear]="true" [nzDropdownMatchSelectWidth]="false"
    [nzBorderless]="borderless" nzDropdownClassName="dropdownSelect" class="width-100" [nzOptionHeightPx]="60"
    [nzOptionOverflowSize]="4" [nzPlacement]="dropdownPlacement">
    <ng-template #displayTpl let-selected>
      <span class="selected-item">
        <span *ngIf="selected?.nzValue?.isRequiredEInvoice && displayEInvReq" nz-icon nzType="info-circle" nz-tooltip
          [nzTooltipTitle]="'Requires issuance of e-Invoice.'" class="tooltip-icon"></span>
        {{ selected.nzLabel }}
      </span>
    </ng-template>

    <!-- Custom Add New Button at top -->
    <ng-container *aclIf="{ ability: ['m1.8', 'stk.create'], mode: 'allOf' }">
      <nz-option *ngIf="!searching && showAddNewButton && !this.NotShowInReport" [nzValue]="null" [nzLabel]="'__addnew__'" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ (storedInstantData || instantData) ? ' Add New \''+ (storedInstantData || instantData) +'\'' : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getLabel(o)" nzCustomContent>
        <div class="stock-item">
          <div class="width-lg max-width-xl">
            <strong>{{ o.code }}</strong>
            <span *ngIf="o.isStockControl" class="float-right">
              <p>
                {{ o.balance | number: '0.0' }}
              </p>
            </span>
            <p><small class="text-grey-dark">{{ o.name }}</small></p>
          </div>
        </div>
      </nz-option>
    </ng-container>
  </nz-select>
</div>